import Page from "components/Page";
import CountriesList from "./CountriesList";

export default () => (
  <Page>
    <CountriesList />
  </Page>
);
